<div class="loading" [class.shimmer]="isLoading">
  <router-outlet role="none"></router-outlet>
</div>
